import { PrepaySearchModel } from "@app/models/myoffice/order/prepay-search.model";
import { ResultProc } from "@app/models/system/result-proc.model";
import { createAction, props } from "@ngrx/store";

// pay card prepay
export const payCardPrepay = createAction(
    "[Prepay Register API] pay card prepay",
    props<{ params: any }>()
);
  
export const payCardPrepaySuccess = createAction(
    "[Prepay Register API] pay card prepay success",
    props<{ result: ResultProc }>()
);
  
export const payCardPrepayFailure = createAction(
    "[Prepay Register API] pay card prepay failure",
    props<{ msg: any }>()
);

export const setPayCardPreResult = createAction(
    "[Prepay Card Result] set card result",
    props<{ preCardResult: ResultProc }>()
  );

// save prepay
export const savePrepay = createAction(
    "[Prepay Register API] save prepay",
    props<{ params: any }>()
);
  
export const savePrepaySuccess = createAction(
    "[Prepay Register API] save prepay success",
    props<{ result: ResultProc }>()
);
  
export const savePrepayFailure = createAction(
    "[Prepay Register API] save prepay failure",
    props<{ msg: any }>()
);

// search
export const searchPrepay = createAction(
    "[Prepay API] search prepay",
    props<{ params: any }>()
);
  
export const searchPrepaySuccess = createAction(
    "[Prepay API] search prepay success",
    props<{ prepay: PrepaySearchModel[] }>()
);
  
export const searchPrepayFailure = createAction(
    "[Prepay API] search prepay failure",
    props<{ msg: any }>()
);

// count
export const countPrepay = createAction(
    "[Prepay API] count prepay",
    props<{ params: any }>()
);
  
export const countPrepaySuccess = createAction(
    "[Prepay API] count prepay success",
    props<{ count: Number }>()
);
  
export const countPrepayFailure = createAction(
    "[Prepay API] count prepay failure",
    props<{ msg: any }>()
);

// count check Pre
export const countCheckPrepay = createAction(
    "[Prepay API] count check prepay",
    props<{ params: any }>()
);
  
export const countCheckPrepaySuccess = createAction(
    "[Prepay API] count check prepay success",
    props<{ count: Number }>()
);
  
export const countCheckPrepayFailure = createAction(
    "[Prepay API] count check prepay failure",
    props<{ msg: any }>()
);

// delete prepay
export const deletePrepay = createAction(
    "[Prepay Register API] delete prepay",
    props<{ userid:string, moneyNo:string}>()
);
  
export const deletePrepaySuccess = createAction(
    "[Prepay Register API] delete prepay success",
    props<{ result: ResultProc }>()
);
  
export const deletePrepayFailure = createAction(
    "[Prepay Register API] delete prepay failure",
    props<{ msg: any }>()
);

export const setDeletePrepay = createAction(
    "[Prepay Register API] set delete prepay result",
    props<{ deleteResult: ResultProc }>()
);